query GetGlobalBlocklistedEmails {
    globallyBlocklistedEmails {
        emailAddress
    }
}
